export default __webpack_public_path__ + "static/ScreenCrowBlack-aea6d0ac9cfe32d53a32510edd799e21.png";